export type VideoCategory = 'movie' | 'tv' | 'variety';

export interface Video {
  id: string;
  title: string;
  category: VideoCategory;
  region: string;
  year: number;
  updateDate: string;
  rating: number;
  views: number;
  cover: string;
  description: string;
  tags: string[];
}

export interface CategoryMeta {
  key: VideoCategory;
  name: string;
  icon: string;
  intro: string;
  banner?: string;
}

export const CATEGORY_META: CategoryMeta[] = [
  {
    key: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    intro: '精选海内外院线佳片与经典电影，涵盖科幻、悬疑、爱情、动作等多种类型，高清画质畅快观看。',
  },
  {
    key: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    intro: '热门国剧、美剧、韩剧、日剧持续更新，剧情、都市、悬疑、古装应有尽有，追剧不迷路。',
  },
  {
    key: 'variety',
    name: '综艺',
    icon: 'ri-mic-line',
    intro: '音乐、竞技、美食、脱口秀等多样综艺节目，轻松欢乐不间断，紧跟当下热门话题。',
  },
];

export const REGION_OPTIONS = [
  '全部',
  '中国大陆',
  '中国香港',
  '美国',
  '日本',
  '韩国',
  '英国',
  '法国',
  '泰国',
];

export const YEAR_OPTIONS = ['全部', '2025', '2024', '2023', '2022', '2021', '2020'];

export const SORT_OPTIONS: { key: 'update' | 'hot'; label: string }[] = [
  { key: 'update', label: '更新时间' },
  { key: 'hot', label: '热度' },
];

export const getCategoryMeta = (key: string): CategoryMeta | undefined =>
  CATEGORY_META.find((item) => item.key === key);